const replaceBlueTooth = (text = '') => {
  const bluetooth = 'Bluetooth'
  const includes = text.indexOf(bluetooth) > -1
  if (!includes) {
    return text
  }
  return text.replace(/Bluetooth/g, `Bluetooth<sup>®</sup>`)
}

const removeBlueToothSymbol = (text = '') => {
  const bluetooth = '<sup>®</sup>'
  const includes = text.indexOf(bluetooth) > -1
  if (!includes) {
    return text
  }
  return text.replace(new RegExp(bluetooth, 'g'), '')
}

export default replaceBlueTooth

export {
  removeBlueToothSymbol
}
